import { Swiper, Navigation, Pagination } from "../swiper.js";

function initVideoSlider() {
  const videoSliders = document.querySelectorAll(".swiper-video");

  if (!videoSliders.length) return;

  videoSliders.forEach((container) => {
    const nextButton = container.querySelector(".swiper-button-next");
    const prevButton = container.querySelector(".swiper-button-prev");
    const pagination = container.querySelector(".swiper-pagination");
    const wrapper = container.closest(".video-slider") || container.parentElement;
    const controls = wrapper?.querySelector(".carousel-controls");

    new Swiper(container, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.2,
      spaceBetween: 20,
      pagination: {
        el: pagination,
        type: "progressbar",
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        init: function () {
          updateControlsVisibility(this);
        },
        resize: function () {
          updateControlsVisibility(this);
        },
      },
      breakpoints: {
        768: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });

    function updateControlsVisibility(swiper) {
      if (!controls) return;
      const slidesPerView = swiper.params.slidesPerView;
      const totalSlides = swiper.slides.length;

      if (totalSlides <= slidesPerView) {
        controls.style.display = "none";
      } else {
        controls.style.display = "";
      }
    }
  });
}

export default initVideoSlider;
